import api from '../token';

export const ListEstoque = async () => {
  try {
    const response = await api.post('/getEstoque');
    return response.data;
  } catch (error) {
    
    return [];
  }
};

